import { SOCIALS } from '@/constants/links'

export default {
  name: 'Footer',
  data () {
    return {
      year: (new Date()).getFullYear(),
      SOCIALS: SOCIALS
    }
  },
}
